import React from 'react';

export default function TablaSinDatos(props) {
    return (
        <div>
        <br /><span className='fs-5 text-info'><i className="fas fa-info fa-circle-info"></i> {props.mensaje? props.mensaje:"No hay datos que mostrar"}</span><br /><br />
        </div>
    )
}